import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import type { Icon } from 'stream-chat-angular';
import { MatIcon } from '@angular/material/icon';
import { IconModule } from 'stream-chat-angular';

@Component({
  selector: 'app-chat-icon',
  templateUrl: './chat-icon.component.html',
  styleUrl: './chat-icon.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon, IconModule],
})
export class ChatIconComponent implements OnInit, OnChanges {
  @Input() name: Icon | undefined;
  icon?: string;

  readonly mapper: Partial<Record<Icon, string>> = {
    close: 'cancel',
    read: 'done_all',
    delivered: 'check',
    attach: 'attach_file',
    send: 'send',
    action: 'more_vert',
    play: 'play_arrow',
    bin: 'delete',
    pause: 'pause',
    retry: 'refresh',
    'arrow-right': 'arrow_right_alt',
    'arrow-left': 'arrow_left_alt',
    'audio-file': 'mic',
    'unspecified-filetype': 'attach_file',
  };

  ngOnInit(): void {
    this.setImage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['name']) {
      this.setImage();
    }
  }

  private setImage(): void {
    if (this.name) {
      this.icon = this.mapper[this.name] ?? this.name;
    }
  }
}
